import { initializeApp, getApps } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { firebaseConfig, foundersFirstFirebaseConfig, useEmulators } from '../config/firebase';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Cloud Functions
const functions = getFunctions(app);

// Initialize founders-first Firebase app (only if not already initialized)
let foundersFirstApp;
let foundersFirstDb;
try {
  const existingApps = getApps();
  foundersFirstApp = existingApps.find(app => app.name === 'founders-first');
  if (!foundersFirstApp) {
    foundersFirstApp = initializeApp(foundersFirstFirebaseConfig, 'founders-first');
  }
  foundersFirstDb = getFirestore(foundersFirstApp);
} catch (error) {
  console.error('Failed to initialize founders-first Firebase app:', error);
  console.error('Error details:', {
    message: error.message,
    code: error.code
  });
  foundersFirstDb = null;
}

// Connect to emulators in development
if (useEmulators) {
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    console.log('Connected to Firebase emulators');
  } catch (error) {
    console.warn('Failed to connect to Firebase emulators:', error);
  }
}

export { db, functions, foundersFirstDb };
export default app; 